// Default map center (approximately center of continental US)
export const DEFAULT_MAP_CENTER = {
  lat: 39.8283,
  lng: -98.5795,
};

// Default zoom levels
export const DEFAULT_MAP_ZOOM = 5; // Shows most of continental US
export const LOCATION_ZOOM = 10; // Zoom level for 30-mile radius view

// Search placeholder text
export const SEARCH_PLACEHOLDER = "Search by city, state, or camp name...";

// Text formatting utilities
export const formatTextWithParagraphs = (text: string | null | undefined): string => {
  if (!text) return '';
  
  // Replace double line breaks with paragraph breaks
  return text.replace(/\n\n/g, '\n\n');
};

export const hasParagraphBreaks = (text: string | null | undefined): boolean => {
  if (!text) return false;
  return text.includes('\n\n');
};

export const getParagraphCount = (text: string | null | undefined): number => {
  if (!text) return 0;
  return text.split('\n\n').length;
}; 